var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNewspaperWhite = function SvgNewspaperWhite(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.583 15h9.75",
    stroke: "#1B1F3B",
    strokeWidth: 0.781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 6.5h7.032V19h-5.47c-.862 0-1.562-.7-1.562-1.563V6.5Z",
    fill: "#CBD4E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.333 19c.359 0 .703-.158.956-.44.254-.28.396-.662.396-1.06V4.75c0-.199.072-.39.199-.53A.644.644 0 0 1 6.361 4h13.295c.18 0 .352.079.478.22.127.14.198.331.198.53V17.5c0 .398-.142.78-.396 1.06-.253.282-.597.44-.956.44H4.333Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.583 8.5h7.75M9.583 11.5h7.75",
    stroke: "#1B2230",
    strokeWidth: 0.781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNewspaperWhite;